import React, { memo } from 'react'

import UserLoginLink from '../../../components/reward/UserLoginLink'

const UserLoginLinkWrapper = (props) => {
  return <UserLoginLink {...props} />
}

export default memo(UserLoginLinkWrapper)
